import i18next from 'i18next';
import { PaymentMethod, PayoutMetadata, PayoutSource } from '@monorepo/types';
import { Payouts as AirwallexPayouts } from '@airwallex/components-sdk';

export const getPayoutOptions = () => {
  return [
    {
      value: PaymentMethod.Rise,
      label: i18next.t('withdrawFunds:payout_options.rise'),
    },
    {
      value: PaymentMethod.HubCredits,
      label: i18next.t('withdrawFunds:payout_options.hub_credits'),
    },
    {
      value: PaymentMethod.Crypto,
      label: i18next.t('withdrawFunds:payout_options.crypto'),
    },
    {
      value: PaymentMethod.Airwallex,
      label: i18next.t('withdrawFunds:payout_options.bank_transfer'),
    },
  ];
};

export const PAYOUT_MINIMUM = 150;

enum AirwallexFormError {
  InvalidParams = 'INVALID_PARAMS',
  Unauthorized = 'UNAUTHORIZED',
  TokenExpired = 'TOKEN_EXPIRED',
  AuthTimeout = 'AUTH_TIMEOUT',
  FailedLoadScript = 'FAILED_LOAD_SCRIPT',
}

export type AirwallexForm = {
  values: AirwallexPayouts.BeneficiaryFormValue;
  errors: AirwallexFormError[];
};

export type PayoutPayload = WithdrawPayload & {
  amount: number;
  source: PayoutSource;
  sourceId: string;
};

export interface WithdrawPayload {
  amount: number;
  paymentOption: PaymentMethod;
  agreedToTerms: boolean;
  acknowledgeWithdrawFormAccount: boolean;
  metadata?: PayoutMetadata;
}

export type PayoutsAdminSearchableKeys = 'userId';
